import { AbsoluteCenter, AspectRatio, Box, Center, For, Grid, GridItem } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { LayoutSelectors } from '@redux/config/config.selectors';
import { FormattedMessage } from 'react-intl';

import { GridItemComponentEnum } from '@/types/config/gridLayout.types';

type Props = {
  gridLayoutCode: string | null;
};

export default function GridLayout({ gridLayoutCode }: Readonly<Props>) {
  const gridLayouts = useAppSelector(LayoutSelectors.selectAllLayouts);
  const gridLayout = gridLayouts.find((grid) => grid.code === gridLayoutCode);

  if (!gridLayout) {
    return (
      <AspectRatio ratio={16 / 9}>
        <Center
          width="100%"
          aspectRatio="16/9"
          maxHeight="100%"
          maxWidth="100%"
          flexGrow={1}
          gap={0.5}
          padding={0.5}
          border="1px solid black"
        >
          {gridLayoutCode ? (
            <FormattedMessage id="screenConfiguration.unknownLayout" />
          ) : (
            <FormattedMessage id="screenConfiguration.noLayout" />
          )}
        </Center>
      </AspectRatio>
    );
  }

  return (
    <Box position="relative" width="100%" aspectRatio={gridLayout.resolution}>
      <Grid
        templateRows={`repeat(${gridLayout.nbRow}, 1fr)`}
        templateColumns={`repeat(${gridLayout.nbCol}, 1fr)`}
        height="100%"
        width="100%"
        flexGrow={1}
        aspectRatio={gridLayout.resolution}
        position="relative"
        gap={0.5}
        padding={0.5}
        backgroundColor="neutral.black"
      >
        <For each={gridLayout.items}>
          {(item) => (
            <GridItem
              key={item.i}
              backgroundColor="blue.700"
              rowSpan={item.h}
              position="relative"
              colSpan={item.w}
              rowStart={item.y + 1}
              colStart={item.x + 1}
              display="grid"
            >
              <AbsoluteCenter
                fontSize="1em"
                textAlign="center"
                backgroundColor="blue.800"
                paddingX={0.5}
                paddingY={0.25}
              >
                <FormattedMessage id={`grid.components.${item.component}`} />
                {item.component === GridItemComponentEnum.MAP && ` ${item.selectedMap}`}
              </AbsoluteCenter>
            </GridItem>
          )}
        </For>
      </Grid>
    </Box>
  );
}
